<template>
    <section class="protocol_detail_section">
        <h3 class="tit" ref="title" data-depth="0">
            공정도
        </h3>
        <div class="contentsWrap" ref="process" v-if="!isNotPdf">
            <div class="protocol_process_area">
                <p v-show="!imageUrl" class="emptyProcess">공정도가 없습니다.</p>
                <img v-show="imageUrl" :src="`data:image/png;base64,${imageUrl}`" alt="" class="processImage">
            </div>
        </div>
        <div class="contents" v-else>
            <div class="protocol_process_area">
<!--                <img v-if="thumbnailList.length == 1" :src="`data:image/png;base64,${thumbnailList[0].thumbnail}`"-->
<!--                                     alt="" class="processImage">-->
                <div class="roll_board_wrap" v-if="thumbnailList.length > 0">
                    <section class="roll_board_control">
                        <button type="button" class="prev" @click="prevSlide">
                            <span class="blind">슬라이드 이전</span>
                        </button>
                        <button type="button" class="play" v-if="!isPlaying" @click="playSlide">
                            <span class="blind">슬라이드 재생</span>
                        </button>
                        <button type="button" class="stop" v-if="isPlaying" @click="pauseSlide">
                            <span class="blind">슬라이드 정지</span>
                        </button>
                        <button type="button" class="next" @click="nextSlide">
                            <span class="blind">슬라이드 다음</span>
                        </button>
                    </section>
                    <VueSlickCarousel ref="carousel" v-bind="settings">
                        <div v-for="(data, index) in thumbnailList" :key="index">
                            <div v-html="`<b>공정도명 : <b/>` + changeTopLevelTagWithRegex(data.processName, 'b') + `[ ${index+1}` +` / ` + `${thumbnailList.length} ]`"></div>
                            <img  class="fixed-size-image" :src="`data:image/png;base64,${data.thumbnail}`">
                        </div>
                    </VueSlickCarousel>
                </div>
                <p v-else class="emptyProcess">연결된 공정도가 없습니다.</p>
            </div>
        </div>
    </section>
</template>
<script>
    import VueSlickCarousel from "vue-slick-carousel";

    export default {
        props: {
            item: {type: Object, default: {}},
        },
        components: {
            VueSlickCarousel,
        },
        data() {
            return {
                titleEdit: false,
                imageUrl: null,
                isNotPdf: false,
                thumbnailList: [],
                isPlaying: true,
                slides: [1, 2, 3, 4], // 슬라이드 데이터
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 4500,
                    arrows: false, // 기본 화살표 비활성화 (커스텀 버튼 사용)
                    dots: false,
                    infinite: true
                }
            }
        },
        updated() {
            this.$emit('updated', {
                title: this.$refs.title,
                key: this.item.key || null,
                depth: 0,
                type: 'process',
            })
        },
        async mounted() {
            this.isNotPdf = this.$route.path.split("/").includes("editor");
            if (this.isNotPdf) {
                try {
                    let protocolId = this.item.protocolId;
                    this.thumbnailList = [];
                    let response = await this.$wApi.protocol.connectProcessThumbnail({
                        protocolId: protocolId,
                    });
                    if (response != null && response?.length > 0) {
                        response.forEach(item=>{
                            this.thumbnailList.push({"thumbnail" : item.thumbnail, "processName" : item.processName});
                        })
                    }
                } catch (e) {
                    window.alert("공정도 썸네일 조회 중 오류가 발생했습니다.");
                }
            } else {
                let processId = this.$route.query.processId;
                if (!processId && this.item && this.item.processId) {
                    processId = this.item.processId;
                }
                try {
                    let response = await this.$wApi.process.thumbnail.get({processId}, processId);
                    if (response.thumbnail) this.imageUrl = response.thumbnail;
                    else this.imageUrl = '';
                    this.$emit('load-content', this.imageUrl);
                } catch (error) {
                    this.$emit('load-content', false);
                }
            }
        },
        methods: {
            changeTopLevelTagWithRegex(htmlString, newTag) {
                if(htmlString == null || htmlString == ""){
                    return "";
                }
                if(newTag == null || newTag == ""){
                    return "";
                }
                return htmlString.replace(
                    /^<(\w+)([^>]*)>([\s\S]*?)<\/\1>/,
                    `<${newTag}$2> $3 </${newTag}>`
                );
            },
            // for slick
            prevSlide() {
                this.$refs.carousel.prev();
            },
            nextSlide() {
                this.$refs.carousel.next();
            },
            playSlide() {
                this.isPlaying = true;
                this.$refs.carousel.play();
            },
            pauseSlide() {
                this.isPlaying = false;
                this.$refs.carousel.pause();
            }
        },
    }
</script>
<style scoped>
    /* slick */
    @import "@/style/new/lib/slick/slidebanner.css";
    .roll_board_wrap {margin:0 auto;margin-top:50px;box-sizing:border-box; position:relative;width: 85%; max-height: 80vh;height:600px;border:1px solid #ccc;}
    .roll_board_control {position:absolute;right:0;top:0; display:flex;flex-wrap:wrap; z-index:1;}
    .roll_board_control button {width:40px;height:40px; border:1px solid #ccc;background:#fff;cursor:pointer;  margin-right:-1px;margin-top:-1px;}
    .roll_board_control .prev {display:inline-block; background:#fff url("@/style/new/images/common/btn_slide_prev.gif") no-repeat 50% 50%;}
    .roll_board_control .play {display:inline-block; background:#fff url("@/style/new/images/common/btn_slide_play.gif") no-repeat 50% 50%;}
    .roll_board_control .stop {display:inline-block; background:#fff url("@/style/new/images/common/btn_slide_stop.gif") no-repeat 50% 50%;}
    .roll_board_control .next {display:inline-block; background:#fff url("@/style/new/images/common/btn_slide_next.gif") no-repeat 50% 50%;}
    .roll_board {display:block;width:100%;height:100%;}
    .roll_board div {width:100%;height:100%;position:relative;}
    .roll_board h5 {display:inline-block; font-size:16px; position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);}
    .blind {overflow:hidden;position:absolute;width:1px;height:1px;background:0 0;font-size:0!important;color:transparent!important;line-height:0;}
    /* slick */
    .fixed-size-image {
        width: 100%;
        height: 550px; /* roll_board_wrap 에 맞춰서 높이 지정 */
        object-fit: contain;
    }
</style>
